// components/StakeholderList.jsx
import React, { useEffect, useState } from "react";
import { progressService } from "../../../../../services/progressService";
import stars from "../../../../../assets/stars.png";

const StakeholderListCard = ({
  userId,
  mode = "api",           // "api" | "data"
  data = [],              // used when mode = "data"
}) => {
  const [stakeholders, setStakeholders] = useState([]);
  useEffect(() => {
    async function loadData() {
       
      if (mode === "data") {
        setStakeholders(data || []);
        return;
      }

      try {
        const res = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "interpersonal",
          "interpersonal_list"
        );

        const list = Array.isArray(res?.stakeholders)
          ? res.stakeholders
          : [];

        const valid = list.filter((s) => s.name && s.relation);
        setStakeholders(valid);
      } catch (err) {
        console.error("Failed to load stakeholders:", err);
        setStakeholders([]);
      }
    }

    if (mode === "api" && userId) {
      loadData();
    } else if (mode === "data") {
      setStakeholders(data || []);
    }
  }, [mode, data, userId]);

  return (
    <div className="relative w-[394px] h-[520px] bg-white rounded-[25px] shadow-lg border border-[#D9D9D9] overflow-hidden flex flex-col">
      {/* Header */}
      <div className="bg-[#0D1111] min-h-28 text-white py-4 text-center font-semibold text-sm tracking-wide uppercase rounded-t-[25px] border-b border-[#707070]">
        <div className="flex items-center justify-center gap-2 font-gotham font-bold text-[20px] leading-7">
          {/* <span className="text-lg">✨</span> */}
          <img src={stars} alt="Stars" className="w-8 h-8 rotate-180 ml-5" />
          <span>Stakeholders Influencing Your Progression</span>
          {/* <span className="text-lg">✨</span> */}
          <img src={stars} alt="Stars" className="w-8 h-8 mr-5" />
        </div>
      </div>

      {/* List */}
      <div className="stakeholder-list-scroll flex-1 min-h-0 p-5 flex flex-col gap-4 bg-white overflow-y-auto">
        {stakeholders.map((s, i) => (
          <div
            key={i}
            className="flex items-center justify-between border border-[#E5E5E5] rounded-xl px-4 py-3 shadow-sm hover:shadow-md transition"
          >
            <div className="flex items-center gap-3">
              {s.animal ? (
                <img src={s.animal} className="w-8 h-8 object-contain" alt="" />
              ) : (
                <div className="w-8 h-8 rounded-full bg-gray-100" />
              )}

              <div>
                <p className="text-[15px] font-medium text-[#323232] leading-tight">
                  {s.name}
                </p>
                <p className="text-[12px] uppercase text-[#7A7A7A] font-semibold mt-[1px] tracking-wide">
                  {s.relation}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StakeholderListCard;
